import React, { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Typography } from '@mui/material'

import ImageViewerV3 from '../component/imageViewer/ImageViewerV3'
import { ContainerBox } from '../styles/js/Dashboard.style'
import { ImageData } from '../utils/types'
import { get, post } from '../utils/http'
import { LoadingAnimeSpinner } from '../component/common/Loaders'
import { isTokenValid } from '../utils/authVerify'

const StandaloneViewerV2 = () => { 
    const { imageId } = useParams()
    const [imageData, setImageData] = useState<ImageData | null>(null)
    const [image404, setImage404] = useState<boolean>(false)
    const [readonly, setReadonly] = useState<boolean>(false)

    const getImageData = useCallback(async () => {
        try {
            const token = await isTokenValid()
            if (!token) {
                const guest = await post('/auth/guest', {})
                localStorage.setItem('guest-token', guest.token)
                setReadonly(true)
            }
            
            const imageApiUrl = isNaN(Number(imageId)) ? `Images/string-id/${imageId}` : `Images/${imageId}`
            const image = await get(imageApiUrl)

            if (image) setTimeout(() => setImageData(image), 0)
            else throw Error("Image Data not found")
        } catch (err) {
            console.log(err)
            setImage404(true)
        }
    }, [imageId])

    useEffect(() => {
        getImageData()
    }, [getImageData])

    const resetMap = () => {
        if (!imageData) return
        const temp = {...imageData}
        setImageData(null)
        setTimeout(() => setImageData(temp), 0)
    }

    return (
        <ContainerBox className='align-items-center justify-content-center'>
            {imageData
                ? <ImageViewerV3
                    key={imageData.id}
                    imageData={imageData}
                    resetMap={resetMap}
                    readonly={readonly}
                />
                : image404
                    ? <Typography component='h1' variant="h5">Slide data not found</Typography>
                    : <LoadingAnimeSpinner />
            }
        </ContainerBox>
    )
}

export default StandaloneViewerV2